export default {
  StateOfTexasLogoAlt: `Estado de Tejas Logo`,
  Copyright: `Derechos de autor &copy; ${new Date().getFullYear()} Estado de Tejas. Todos los derechos reservados.`,
  CallSupport: `Póngase en contacto con su organización para obtener asistencia`,
};
